import { useQuery } from '@tanstack/react-query';
import { Sorting, useFiltersContext } from '../../context/useFiltersContext';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';

export type ResultsResponse<T> = {
  results: T;
  total: number;
};

export type ImageType = {
  id: number;
  type: string;
  alt: string;
  path: string;
  hash: string;
};

export type PriceType = {
  image: ImageType;
  milesAmount: number;
};

export type ProductCardType = {
  id: number;
  name: string;
  slug: string;
  price: PriceType;
  priceOverwrite?: PriceType;
  defaultImage: ImageType;
  localizedImage: ImageType;
};

export type ProductsFilter = {
  attributes: number[];
  attrKeyCount: number;
  categoryId: number;
  subCatList: number[];
  maxPrice?: number;
  minPrice?: number;
  sort: Sorting[];
  skip: number;
};

export default function useProducts(filter: ProductsFilter) {
  const localeFilter = useLocaleQueryFilter(filter);
  const accessPhysicalProduct = window.config?.ACCESS_PHYSICAL_PRODUCT;
  const accessBonus = window.config?.ACCESS_BONUS;
  const { setRefetch } = useFiltersContext();

  return useQuery<ResultsResponse<ProductCardType[]>, Error>(
    [
      'products/findAllByCategory',
      { ...localeFilter, accessPhysicalProduct, accessBonus },
    ],
    {
      onSettled: () => {
        setRefetch(false);
      },
      keepPreviousData: true,
    },
  );
}
